import { createAsyncThunk, ThunkDispatch } from '@reduxjs/toolkit';
import attachmentService from './Attachment.service';
import {
  AttachFetchType,
  AttachListFetch,
  AttachObjectType,
  AttachDownloadFetch,
} from './Attachment.type';
import { errorHandlerThunk } from '../App/App.thunk';

export const getAttachmentTypesThunk = createAsyncThunk(
  'attachments/getAttachmentTypesThunk',
  async (_: any, thunkAPI) => {
    const response = await attachmentService.getTypes();
    return response.data;
  },
);

export const getAttachmentListThunk = createAsyncThunk(
  'attachments/getAttachmentListThunk',
  async (params: AttachListFetch, thunkApi) => {
    const response = await attachmentService.getList(params);
    return response.data;
  },
);

export const getAttachmentDownloadThunk = createAsyncThunk(
  'attachments/getAttachmentDownloadThunk',
  async (params: AttachDownloadFetch, thunkApi) => {
    const response = await attachmentService.getAttachmentDownload(params);
    return response.data;
  },
);

export const syncAttachmentsThunk =
  (object: AttachObjectType, attachments: AttachFetchType[]) =>
  (dispatch: ThunkDispatch<any, any, any>) => {
    return attachmentService
      .sync(object, attachments)
      .then(() => {
        return true;
      })
      .catch(err => {
        dispatch(errorHandlerThunk(err));

        return false;
      });
  };
